import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_DIGITAL_TWIN_INLCM_3 = {
  title: `<span style="color: #BEE3FF;">Generate the proposed network plan</span>\n\nComparison view of existing and \nproposed network plan brief.`,
  subtitle: "Digital Twin for Network Transformation",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_313"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_311"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/INLCM/INLCM_dark_bg_2.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ENG/INLCM/INLCM_digital_twin_01_computer.png",
          effect: "animate-opacity",
          imageStyle: { position: "absolute", bottom: "160px", right: "0px" },
        },
        {
          image: "ENG/INLCM/INLCM_digital_twin_03_screen.png",
          imageStyle: { position: "absolute", bottom: "245px", right: "83px" },
        },
        {
          image: "ENG/INLCM/INLCM_digital_twin_03_check.png",
          imageStyle: { position: "absolute", bottom: "49px", right: "21px" },
        },
      ]}
      pageNumber={"ENG_312"}
    />
  ),
};
